import React, { useState } from "react";
import {
  AvatarGroup,
  Avatar,
  Box,
  Button,
  Flex,
  Icon,
  Image,
  Link,
  Text,
  useColorModeValue,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Select,
  Input,
} from "@chakra-ui/react";
import { IoHeart, IoHeartOutline } from "react-icons/io5";
import {
  FaCode,
  FaLaptopCode,
  FaDatabase,
  FaBrain,
  FaUsersCog,
  FaUtensils,
  FaPencilRuler,
  FaCamera,
  FaMusic,
  FaTasks,
  FaLightbulb,
  FaComments,
  FaPenNib,
  FaVideo,
  FaPaintBrush
} from "react-icons/fa";
import { BiCodeAlt } from "react-icons/bi";
import { FaRobot } from "react-icons/fa";
import Card from "components/card/Card.js";
import { useNavigate } from "react-router-dom";
import { NUMBER_OF_LESSONS } from "utils/Constants";

const skillIconMap = {
  javascript: FaCode,
  react: FaLaptopCode,
  sql: FaDatabase,
  python: FaCode,
  react_native: FaLaptopCode,
  full_stack_developer: BiCodeAlt,
  problem_solving: FaBrain,
  management: FaUsersCog,
  cooking: FaUtensils,
  graphic_design: FaPencilRuler,
  photo: FaCamera,
  music: FaMusic,
  productivity: FaTasks,
  intelligence: FaLightbulb,
  communication: FaComments,
  writing: FaPenNib,
  video: FaVideo,
  drawing: FaPaintBrush,
};

const normalizeSkillName = (name) => name.toLowerCase().replace(/\s+/g, "_");

const getSkillIcon = (name) => {
  const normalizedName = normalizeSkillName(name);
  for (const key in skillIconMap) {
    if (normalizedName.includes(key)) {
      return skillIconMap[key];
    }
  }
  return FaRobot;
};

export default function Skill(props) {
  const { image, name, bidders, learnItLink, userLevels, userStartedThisAlready, currentLearningLevels, completedAllLevels } = props;
  const navigate = useNavigate();
  const [like, setLike] = useState(false);
  const [numLessons, setNumLessons] = useState(1);
  const [selectedLevel, setSelectedLevel] = useState(""); // State for selected level
  const { isOpen, onOpen, onClose } = useDisclosure(); // Modal controls

  const textColor = useColorModeValue("navy.700", "white");
  const textColorBid = useColorModeValue("brand.500", "white");
  const iconColor = useColorModeValue('#11047a', 'white');
  let optionsForLevels = currentLearningLevels ? currentLearningLevels.split(", ") : [];

  const filteredUserLevels = userLevels.filter(
    (level) => !optionsForLevels.includes(level.toLowerCase())
  );

  const currentlyLearningLevel = userLevels.filter(
    (level) => optionsForLevels.includes(level.toLowerCase())
  )?.map(level=> level.toLowerCase())

  const handleStartLearning = () => {
    onClose();
    navigate(`${learnItLink}?numLessons=${numLessons}&currentLevel=${selectedLevel}`);
  };

  const SkillIcon = getSkillIcon(name)
  return (
    <Card p="20px">
      <Flex direction={{ base: "column" }} justify="space-between" height={'100%'}>
        <Flex
          direction={{ base: "column" }}
          justify="center"
          align={"center"}
          mb={{ base: "20px", "2xl": "20px" }}
        >
          {/* <Image
            src={image}
            w={{ base: "100%", "3xl": "100%" }}
            h={{ base: "100%", "3xl": "100%" }}
            borderRadius="20px"
          /> */}
          <Icon
            as={SkillIcon}
            boxSize="50px"
            color={iconColor}
            borderRadius="20px"
          />
          {/* <Button
            position="absolute"
            bg="white"
            _hover={{ bg: "whiteAlpha.900" }}
            _active={{ bg: "white" }}
            _focus={{ bg: "white" }}
            p="0px !important"
            top="14px"
            right="14px"
            borderRadius="50%"
            minW="36px"
            h="36px"
            onClick={() => {
              setLike(!like);
            }}
          >
            <Icon
              transition="0.2s linear"
              w="20px"
              h="20px"
              as={like ? IoHeart : IoHeartOutline}
              color="brand.500"
            />
          </Button> */}
        </Flex>
        <Flex
          flexDirection="column"
          justify="center"
          align={"center"}
          h="100%"
        >
          <Text
            color={textColor}
            fontSize={{
              base: "xl",
              md: "lg",
              lg: "lg",
              xl: "lg",
              "2xl": "md",
              "3xl": "lg",
            }}
            mb="5px"
            fontWeight="bold"
            me="14px"
          >
            {name}
          </Text>
        </Flex>
        <Flex justify="center" align={"center"} mt="25px">
          {userStartedThisAlready ? (
            <>
              <Button fontSize={12} variant="darkBrand" color="white" onClick={() => navigate(`${learnItLink}?currentLevel=${currentlyLearningLevel[0] ?? 'beginner'}`)}>
                Continue
              </Button>

              {!completedAllLevels ? (<Button fontSize={12} paddingLeft={5} paddingRight={5} variant="darkBrand" color="white" ml="10px" onClick={onOpen}>
                Start Another Level
              </Button>) : ''}
            </>
          ) : (
            <Button variant="darkBrand" color="white" onClick={onOpen}>
              Learn
            </Button>
          )}
        </Flex>
      </Flex>

      {/* Modal */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Start Learning</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text mb="10px">Select the number of lessons:</Text>
            <Select
              placeholder="Select number of lessons"
              value={numLessons}
              onChange={(e) => setNumLessons(e.target.value)}
            >
              {NUMBER_OF_LESSONS.map((level, index) => (
                <option key={index} value={level}>
                  {level}
                </option>
              ))}
            </Select>
            <Text mb="10px">Select your current level:</Text>
            <Select
              placeholder="Select your level"
              value={selectedLevel}
              onChange={(e) => setSelectedLevel(e.target.value)}
            >
              {filteredUserLevels.map((level, index) => (
                <option key={index} value={level}>
                  {level}
                </option>
              ))}
            </Select>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              onClick={handleStartLearning}
              ml="10px"
              isDisabled={!selectedLevel}
            >
              Start
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Card>
  );
}
